var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { getInputProp, onInputChange, setInputInactive, setInputActive, OuterContainer, LabelContainer, Container, TextFieldContainer } from './Input';
import { Label, Icon } from '..';
import { getColor } from '../helpers/ColorHelpers';
var IconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 20px;\n    vertical-align: top;\n    padding: 5px 0 5px 5px;\n    background:transparent;\n    grid-column: 1;\n    -ms-grid-column: 1;\n    grid-row: 2;\n    -ms-grid-row: 2;\n    svg{\n      stroke: ", ";\n    }\n"], ["\n    width: 20px;\n    vertical-align: top;\n    padding: 5px 0 5px 5px;\n    background:transparent;\n    grid-column: 1;\n    -ms-grid-column: 1;\n    grid-row: 2;\n    -ms-grid-row: 2;\n    svg{\n      stroke: ", ";\n    }\n"])), function (props) { return getColor(props, getInputProp(props, props.focused, "borderColor")); });
var TextAreaContainer = styled.textarea(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", ";\n    width: ", ";\n    grid-column: ", ";\n    -ms-grid-column: ", ";\n    grid-row: 1 / span 3;\n    -ms-grid-row: 1;\n    -ms-grid-row-span: 3;\n    height:100px;\n    font-family: ", ";\n    //font-size:smaller;\n    font-weight:400;\n    resize: none;\n    background: transparent;\n    padding: 10px;\n    border: none;\n    cursor: inherit;\n    color: ", ";\n    &:focus {\n      outline: none;\n  }\n"], ["\n    border-radius: ", ";\n    width: ", ";\n    grid-column: ", ";\n    -ms-grid-column: ", ";\n    grid-row: 1 / span 3;\n    -ms-grid-row: 1;\n    -ms-grid-row-span: 3;\n    height:100px;\n    font-family: ", ";\n    //font-size:smaller;\n    font-weight:400;\n    resize: none;\n    background: transparent;\n    padding: 10px;\n    border: none;\n    cursor: inherit;\n    color: ", ";\n    &:focus {\n      outline: none;\n  }\n"])), function (props) { return props.theme.form.borderRadius; }, function (props) { return props.width ? props.width : "100%"; }, function (p) { return p.withLabel ? 2 : 1; }, function (p) { return p.withLabel ? 2 : 1; }, function (props) { return props.theme.fontFamily; }, function (props) { return getColor(props, getInputProp(props, props.focused, "color")); });
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = React.createRef();
        _this.setFocus = function () {
            setTimeout(function () { return _this.setState({ focused: true }, function () {
                var _a;
                if (_this.ref)
                    (_a = _this.ref.current) === null || _a === void 0 ? void 0 : _a.focus();
            }); }, 0);
        };
        _this.state = {
            focused: false
        };
        return _this;
    }
    TextArea.prototype.componentDidMount = function () {
        if (this.props.setFocusFunction)
            this.props.setFocusFunction(this.setFocus);
    };
    TextArea.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.autoFocus !== this.props.autoFocus && this.props.autoFocus && !this.state.focused)
            this.setFocus();
    };
    TextArea.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, kind = _b.kind, placeHolder = _b.placeHolder, labelInside = _b.labelInside, icon = _b.icon, onClick = _b.onClick, onBlur = _b.onBlur, width = _b.width, rest = __rest(_b, ["kind", "placeHolder", "labelInside", "icon", "onClick", "onBlur", "width"]);
        var kindWithDefault = kind !== null && kind !== void 0 ? kind : "default";
        var change = function (e) { return onInputChange(_this, e); };
        var click = function (e) { return setInputActive(_this, e); };
        var blur = function (e) { return setInputInactive(_this, e); };
        var withLabel = (!labelInside && icon !== undefined);
        //console.log("HEIGHT=>", this.props.heightTextarea);
        return (React.createElement(React.Fragment, null,
            React.createElement(OuterContainer, null,
                React.createElement(Container, { width: width, kind: kind, focused: this.state.focused, inline: (_a = this.props.inline) !== null && _a !== void 0 ? _a : false },
                    labelInside &&
                        React.createElement(LabelContainer, null,
                            React.createElement(Label, { icon: icon, content: labelInside })),
                    React.createElement(TextFieldContainer, { withLabel: withLabel },
                        !labelInside && icon &&
                            React.createElement(IconContainer, { focused: this.state.focused, kind: kindWithDefault },
                                React.createElement(Icon, { name: icon })),
                        React.createElement(TextAreaContainer, __assign({ withLabel: withLabel, focused: this.state.focused, onClick: click, onBlur: blur, onChange: change, kind: kind }, this.props, { placeholder: placeHolder, ref: this.ref })))))));
    };
    return TextArea;
}(React.PureComponent));
export default TextArea;
var templateObject_1, templateObject_2;
//# sourceMappingURL=TextArea.js.map